import { jsx as l } from "react/jsx-runtime";
import { useChatbotContext as p } from "../../hooks/useChatbotContext.js";
function x() {
  const {
    isEditing: i,
    isLoading: r,
    input: n,
    handleInputChange: a,
    chatbot: o,
    ReactTextareaAutosize: s
  } = p();
  return /* @__PURE__ */ l(
    s,
    {
      className: "max-h-44 grow resize-none overflow-y-auto rounded-medium bg-transparent px-4 py-[14px] text-base leading-[1.5] text-inherit placeholder:text-card-foreground/65 focus-visible:outline-none disabled:cursor-wait disabled:opacity-60 @notMobile:max-h-28 @notMobile:py-[17px] @notMobile:pl-5 @notMobile:pr-1 @notMobile:text-[14.5px] min-[409px]:max-[409px]:text-[14.5px]",
      disabled: i || r,
      value: n,
      onChange: a,
      placeholder: o == null ? void 0 : o.placeholder,
      "data-testid": "user-prompt",
      onKeyDown: (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
          e.preventDefault();
          const t = e.currentTarget.closest("form");
          t && (t.requestSubmit ? t.requestSubmit() : t.submit());
        }
      }
    }
  );
}
export {
  x as UserMessageInput
};
